import React, { useState, useEffect } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableRow, Paper,
    TableHead, TablePagination, TextField, Dialog,
    DialogActions, DialogContent, Box, DialogContentText, DialogTitle, Button, Typography, Link
} from '@mui/material';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import AddObjetivo from './AddObjetivo';
import { useAccesos } from '../contexts/AccesosContext';



function GestionObjetivo({idCampania = null, objetivos: objetivosProp = null}) {

    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [objetivos, setObjetivos] = useState([]);
    const [editObjetivo, setEditObjetivo] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [objetivoToDelete, setObjetivoToDelete] = useState(null);
    const { user } = useUser();      
    const { tienePermiso } = useAccesos();
    // Estado con tareas simuladas
    

    const fetchObjetivos = async () => {
                    try {
                        const response = await fetch(`${server}/CrmObjetivoCampaniums/poridCampania/${idCampania}`);
                        const data = await response.json();
                        setObjetivos(data.$values);
                    } catch (error) {
                        console.error('Error al cargar los Objetivos:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al cargar los Objetivos: ' + error,
                        });
                    }
                };

            useEffect(() => {
                const fetchObjetivos = async () => {
                    try {
                        let response;
                        if(idCampania) {
                            response = await fetch(`${server}/CrmObjetivoCampaniums/poridCampania/${idCampania}`);
                        } else {
                            response = await fetch(`${server}/CrmObjetivoCampaniums`);
                        }

                        const data = await response.json();
                        setObjetivos(data.$values || []);
                    } catch (error) {
                        console.error('Error al cargar los objetivos', error);
                        Swal.fire({
                            icon:'error',
                            title:'Error',
                            text: 'Error al cargar los objetivos: '+ error,
                        });
                    }

                };

                    fetchObjetivos();
                
            }, [idCampania, objetivosProp]);

            if (!idCampania) {
                    return (
                    <Typography variant="body1" color="textSecondary">
                        Selecciona una campaña para ver sus objetivos.
                    </Typography>
                );
            }
        
            const handleNewObjetivo = () => {
                if(idCampania) {
                    fetch(`${server}/CrmObjetivoCampaniums/poridCampania/${idCampania}`)
                    .then(res => res.json())
                    .then(data => setObjetivos(data.$values || []))
                    .catch(console.error);
                }else{
                    fetch(`${server}/CrmObjetivoCampaniums`)
                    .then(res => res.json())
                    .then(data => setObjetivos(data.$values || []))
                    .catch(console.error);
                }
                
                setEditObjetivo(null);
            };
        
            const handleChangePage = (event, newPage) => {
                setPage(newPage);
            };
        
            const handleChangeRowsPerPage = (event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
            };
        
            const handleSearchChange = (event) => {
                setSearchQuery(event.target.value);
            };
        
            const handleOpenDialog = (objetivo) => {
                setObjetivoToDelete(objetivo);
                setOpenDialog(true);
            };
        
            const handleCloseDialog = () => {
                setOpenDialog(false);
                setObjetivoToDelete(null);
            };
        
            const handleDeleteObjetivo = async () => {
                if (objetivoToDelete) {
                    try {
                        const username = ''+user.codigoUsuario+'/';
        
                        const response = await fetch(`${server}/CrmObjetivoCampaniums/${objetivoToDelete.idObjetivo}/${username}`,
                             {
                            method: 'DELETE'
                        });
                        if (response.ok) {
                            handleCloseDialog();
                            fetchObjetivos(); // Recargar la lista de campanias
                            Swal.fire({
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Objetivo eliminado con éxito',
                            });
                        } else {
                            handleCloseDialog();
        
                            const errorData = await response.json();
                            const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                            Swal.fire({
                                icon: 'error',
                                title: `Error ${response.status}`,
                                text: errorMessage,
                            });
                        }
                    } catch (error) {
                        console.error('Error al eliminar el objetivo:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al eliminar el objetivo: ' + error,
                        });            }
                }
            };
        
            const filteredObjetivo = objetivos.filter(objetivo => objetivo.tituloObjetivo?.toLowerCase().includes(searchQuery.toLowerCase()));
    
    const handleCancelarEdicion = () => {
        setEditObjetivo(null);
    }

    return (
        <>
            <div className="x_content">
                <br />
                
                < AddObjetivo handleNewObjetivo={handleNewObjetivo} editObjetivo={editObjetivo} idCampania={idCampania} cancelarEdicion={handleCancelarEdicion}/>
                <div className="ln_solid" />
                <h2>Objetivos Existentes</h2>

                <TextField
                    fullWidth
                    variant="outlined"
                    label="Buscar Objetivo"
                    placeholder="Buscar..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{ marginBottom: '20px' }}
                />

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="right"><strong>Acciones</strong></TableCell>
                                <TableCell><strong>Título</strong></TableCell>
                                <TableCell><strong>Descripción</strong></TableCell>
                                <TableCell><strong>Tipo Objetivo</strong></TableCell>
                                <TableCell><strong>Meta</strong></TableCell>
                                <TableCell><strong>Cumplido</strong></TableCell>
                                <TableCell><strong>Resultado</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredObjetivo.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((objetivo) => (
                            <TableRow key={objetivo.idObjetivo}>
                                <TableCell align="right">
                                    <Button onClick={() => setEditObjetivo(objetivo)} color="primary" disabled={!tienePermiso('Editar Objetivo')}>
                                        Editar
                                    </Button>
                                    <Button onClick={() => handleOpenDialog(objetivo)} color="secondary" disabled={!tienePermiso('Eliminar Objetivo')}>
                                        Eliminar
                                    </Button>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {objetivo.tituloObjetivo}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {objetivo.decripcionObjetivo}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {objetivo.tipoObjetivo}
                                </TableCell>
                                {/* <TableCell component="th" scope="row">
                                    {objetivo.IdCampania}
                                </TableCell> */}
                                <TableCell component="th" scope="row">
                                    {objetivo.meta}
                                </TableCell>
                                {/* <TableCell component="th" scope="row">
                                    {objetivo.cumplido ? 'Sí' : 'No'}
                                </TableCell> */}
                                {<TableCell component="th" scope="row">
                                    <span style={{
                                        padding: '4px 8px',
                                        borderRadius: '5px',
                                        color: 'white',
                                        background:
                                        objetivo.cumplido ? 'green' : 'red'
                                    }}>
                                        {objetivo.cumplido ? 'Si' : 'No'}
                                    </span>
                                </TableCell>}
                                <TableCell component="th" scope="row">
                                    {objetivo.resultado}
                                </TableCell>
                            </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={objetivos.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
                    <Dialog open={openDialog}
                        onClose={handleCloseDialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                        <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            ¿Estás seguro de que quieres eliminar este objetivo?
                        </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                        <Button onClick={handleDeleteObjetivo} color="primary" autoFocus>Eliminar</Button>
                        </DialogActions>
                    </Dialog>

                 
            </div>
        </>
    );
}

export default GestionObjetivo;